import { render, staticRenderFns } from "./ProductoImg.vue?vue&type=template&id=7fe4da40&scoped=true"
import script from "./ProductoImg.vue?vue&type=script&lang=js"
export * from "./ProductoImg.vue?vue&type=script&lang=js"
import style0 from "./ProductoImg.vue?vue&type=style&index=0&id=7fe4da40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4da40",
  null
  
)

export default component.exports